
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  DialogFooter,
} from '@/components/ui/dialog';
import { Club } from '@/hooks/useClubs';
import { Season } from '@/types/season';

interface SeasonFormProps {
  clubs: Club[];
  editingSeason: Season | null;
  seasonYear: string;
  setSeasonYear: (value: string) => void;
  seasonName: string;
  setSeasonName: (value: string) => void;
  selectedClubId: string;
  setSelectedClubId: (value: string) => void;
  isSubmitting: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}

export const SeasonForm: React.FC<SeasonFormProps> = ({
  clubs,
  editingSeason,
  seasonYear,
  setSeasonYear,
  seasonName,
  setSeasonName,
  selectedClubId,
  setSelectedClubId,
  isSubmitting,
  onSubmit,
  onCancel,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Label htmlFor="club-select">Club</Label>
          <Select value={selectedClubId} onValueChange={setSelectedClubId} required>
            <SelectTrigger>
              <SelectValue placeholder="Select a club" />
            </SelectTrigger>
            <SelectContent>
              {clubs.map((club) => (
                <SelectItem key={club.id} value={club.id}>
                  {club.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="season-year">Season Year</Label>
          <Input
            id="season-year"
            type="number"
            value={seasonYear}
            onChange={(e) => setSeasonYear(e.target.value)}
            placeholder="e.g., 2025"
            required
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="season-name">Season Name</Label>
          <Input
            id="season-name"
            value={seasonName}
            onChange={(e) => setSeasonName(e.target.value)}
            placeholder="e.g., 2025 Season"
            required
          />
        </div>
      </div>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : editingSeason ? 'Update' : 'Create'}
        </Button>
      </DialogFooter>
    </form>
  );
};
